/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ChartNoAxesGantt = [
  ["path", { d: "M6 5h12" }],
  ["path", { d: "M4 12h10" }],
  ["path", { d: "M12 19h8" }]
];

export { ChartNoAxesGantt as default };
//# sourceMappingURL=chart-no-axes-gantt.js.map
